import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import './styles.css';

// Bewusst ohne <StrictMode>: dessen doppelter Effekt-Durchlauf im
// Entwicklungsmodus wuerde WebGL-Kontext und Rapier-Welt zweimal aufbauen
// und wieder abraeumen. Die Spielschleife lebt ohnehin ausserhalb von React.
const container = document.getElementById('ui-root');
if (!container) throw new Error('#ui-root fehlt');

createRoot(container).render(<App />);

// Doppeltipp-Zoom und Gummiband-Scrollen auf iOS unterbinden.
document.addEventListener('gesturestart', (e: Event) => e.preventDefault());
document.addEventListener(
  'touchmove',
  (e) => {
    if (e.touches.length > 1) e.preventDefault();
  },
  { passive: false },
);
